export default () => ({
  notifications: [],
});
